<ds-themed-badges *ngIf="showLabel" [object]="dso"></ds-themed-badges>
<ds-truncatable [id]="dso.id">
    <a *ngIf="linkType != linkTypes.None" [target]="(linkType == linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType == linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
            [routerLink]="[itemPageRoute]" class="lead item-list-title dont-break-out"
            [innerHTML]="dsoTitle"></a>
    <span *ngIf="linkType == linkTypes.None"
          class="lead item-list-title dont-break-out"
          [innerHTML]="dsoTitle"></span>
    <span class="text-muted">
    <ds-truncatable-part [id]="dso.id" [minLines]="1">
            <span *ngIf="dso.allMetadata(['publicationvolume.volumeNumber']).length > 0"
                  class="item-list-journal-issues">
                    <span *ngFor="let value of allMetadataValues(['publicationvolume.volumeNumber']); let last=last;">
                        <span [innerHTML]="value"><span [innerHTML]="value"></span></span>
                    </span>
                <span *ngIf="dso.allMetadata(['publicationissue.issueNumber']).length > 0"
                      class="item-list-journal-issue-numbers">
                    <span *ngFor="let value of allMetadataValues(['publicationissue.issueNumber']); let last=last;">
                        <span> - </span><span [innerHTML]="value"><span [innerHTML]="value"></span></span>
                    </span>
                </span>
            </span>
        </ds-truncatable-part>
  </span>
</ds-truncatable>
